<template>
  <app-modal :modal-id="modalId"
             @confirm="deleteGroup"
             @cancel="cancel"
  >
    <p class="my-4">Are you sure you want to delete <strong>{{groupId}}</strong>
      <span style="margin-left: 2px;">?</span>
    </p>
  </app-modal>
</template>

<script>
import AppModal from './AppModal';

export default {
  name: 'DeleteGroupConfirmModal',
  props: {
    modalId: {
      type: String,
      required: true,
    },
    groupId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    deleteGroup() {
      this.$emit('deleteGroup', this.groupId);
      this.$root.$emit('bv::hide::modal', this.modalId);
    },
  },
  components: {
    AppModal,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modals/DeleteGroupConfirmModal.vue